export function saveBelongsToRelationship(relationshipName) {
  return async (model) => {
    const record = await model[relationshipName];

    if (record) {
      await record.save();
    }

    return model;
  };
}

export function saveHasManyRelationships(...relationshipNames) {
  return async (model) => {
    const records = await Promise.all(
      relationshipNames.map((relationshipName) => model[relationshipName]),
    );

    await Promise.all(
      records
        .flatMap((records) => {
          if (typeof records?.toArray === 'function') {
            return records.toArray();
          }

          return Array.from(records ?? []);
        })
        .map((record) => record.save()),
    );

    return model;
  };
}

export async function updateUrlAliasParents(model) {
  const urlAliases = await model.urlAliases;
  let parentUrlAlias = urlAliases[0];

  if (parentUrlAlias) {
    parentUrlAlias.parent = null;

    urlAliases.forEach((alias) => {
      if (alias !== parentUrlAlias) {
        alias.parent = parentUrlAlias;
      }
    });
  }

  return model;
}
